module.exports = __webpack_public_path__ + "static/media/ig9.fc276bc6.jpg";